import { ProductMetadata } from 'indices-list'
import { useCallback, useEffect } from 'react'
import { useStore } from 'services/store'
import { GLOBAL_COLORS } from 'theme'
import { InvestStorage } from '../storage/interface'
import { Title, Wrapper } from './styled'

interface BuySellSelectProps {
  store: InvestStorage
  productMetadata: ProductMetadata
  isRetry: boolean
  isRetryInPending: boolean
  isPending: boolean
  successDone: boolean | undefined
  setSuccessDone: (state: boolean | undefined) => void
}

export const BuySellTabComponent = ({
  store,
  productMetadata,
  isRetry,
  isRetryInPending,
  // isPending,
  setSuccessDone,
  successDone,
}: BuySellSelectProps) => {
  const { dispatch, input } = store

  // const transactions = useAtomValue(storedTransactionsAtom)
  // const userAddress = useAtomValue(userAccountAtom)
  // const usersTransactions = transactions.filter(({ account }) =>
  //   isAddressEqual(account, userAddress ?? zeroAddress),
  // )

  // const lastTx: Transaction | undefined = useMemo(
  //   () => usersTransactions[usersTransactions.length - 1],
  //   [usersTransactions],
  // )

  const isBuy = input.asset.address !== productMetadata.address
  const { isDarkMode } = useStore()
  const isStaking = input.asset.type === 'PHTR' || input.asset.type === 'staked-PHTR'
  const activeColor = !isDarkMode ? GLOBAL_COLORS.customBlack : GLOBAL_COLORS.white
  const inactiveColor = !isDarkMode ? GLOBAL_COLORS.investTabGrey : GLOBAL_COLORS.seashellWhite05

  const handleTab = useCallback(() => {
    dispatch({
      type: 'switch-mode',
    })
  }, [dispatch])

  const DefaultBuySellComponent = () => (
    <>
      <Title
        onClick={!isBuy ? handleTab : () => undefined}
        color={isBuy ? activeColor : inactiveColor}
      >
        {isStaking ? 'Stake' : 'Buy'}
      </Title>
      <Title
        onClick={isBuy ? handleTab : () => undefined}
        color={!isBuy ? activeColor : inactiveColor}
      >
        {isStaking ? 'Unstake' : 'Sell'}
      </Title>
    </>
  )

  // const FlowComponent = () => {
  //   const status = isPending ? 'pending' : isRetry ? 'retry' : successDone ? 'success' : 'default'
  //   const symbol = productMetadata.symbol.toUpperCase()
  //   const image = assetsListBySymbol[symbol].icon
  //   const txAmount = lastTx?.action.indexDetails?.value ?? '0'
  //   const amount = (txAmount === '0' ? '<0.01' : transactionAmountFormatter(txAmount)) ?? '0'

  //   const title =
  //     status === 'pending'
  //       ? 'Selling...'
  //       : status === 'success'
  //         ? 'Complete'
  //         : '2nd transaction required'

  //   const doneTransactions =
  //     lastTx?.additionalTransactions?.filter((tx) => tx.status !== TransactionStatus.INFLIGHT)
  //       .length ?? 1

  //   const step =
  //     50 / (lastTx?.additionalChains !== undefined ? lastTx.additionalChains.length + 1 : 2)

  //   const intermediateWidth = step * doneTransactions

  //   const width =
  //     status === 'success'
  //       ? 100
  //       : status === 'retry'
  //         ? 50
  //         : isRetryInPending
  //           ? 50 + intermediateWidth
  //           : 5 + intermediateWidth
  //   const text = isRetryInPending ? 'Trading and bridging assets...' : 'Withdrawing assets...'

  //   status === 'pending' && setSuccessDone(undefined)
  //   const Title = ({ isSuccess }: { isSuccess: boolean }) => {
  //     return isSuccess ? (
  //       <CompleteTextWrapper>
  //         <ImageWrapper>
  //           <CheckMarkIcon />
  //         </ImageWrapper>
  //         <TextContainer>
  //           <CompleteTitle>{title}</CompleteTitle>
  //           <FadeEffect />
  //         </TextContainer>
  //       </CompleteTextWrapper>
  //     ) : (
  //       <PendingTitle>{title}</PendingTitle>
  //     )
  //   }
  //   return (
  //     <PendingContent>
  //       <Title isSuccess={status === 'success'} />
  //       <PendingLabelWrapper>
  //         <PendingAssetIcon src={image} />
  //         <PendingTitle>{`${amount} ${symbol}`}</PendingTitle>
  //       </PendingLabelWrapper>
  //       <ProgressBar
  //         isPulsing={status === 'pending'}
  //         width={width}
  //         isPendingTx={status !== 'retry'}
  //       />
  //       {status === 'pending' && <PendingText>{text}</PendingText>}
  //     </PendingContent>
  //   )
  // }

  // const isDefault = !isPending && !isRetry && !successDone

  useEffect(() => {
    if (successDone) {
      setTimeout(() => {
        setSuccessDone(false)
      }, 3500)
    }
  }, [successDone])

  useEffect(() => {
    if (isRetry && successDone === undefined) {
      setSuccessDone(true)
    }
  }, [isRetryInPending])

  // return <Wrapper>{isDefault ? <DefaultBuySellComponent /> : <FlowComponent />}</Wrapper>
  return (
    <Wrapper>
      <DefaultBuySellComponent />
    </Wrapper>
  )
}
